// extracted by mini-css-extract-plugin
export default {"page":"About_page__c85c2","container":"About_container__bH5z9","title":"About_title__BY5w+","content":"About_content__dxoNt"};